/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CoreModule } from '@dm/core';
import { DMCommonModule } from 'app/common/dm-common.module';

import { FileSystemGuideModule } from '../../../file-system/file-system-guide/file-system-guide.module';
import { AddUserOrGroupComponent } from './add-user-or-group.component';

@NgModule({
    declarations: [AddUserOrGroupComponent],
    exports: [AddUserOrGroupComponent],
    imports: [
        CommonModule,
        CoreModule,
        ReactiveFormsModule,
        DMCommonModule,
        FileSystemGuideModule,
    ],
})
export class AddUserOrGroupModule { }
